"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegistrationCandidateForm = RegistrationCandidateForm;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const Api = __importStar(require("@src/api"));
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const DataProcessingOrNewsletterModal_1 = require("@src/components/modules/global/DataProcessingOrNewsletterModal");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const PersonalInformation_1 = require("./PersonalInformation");
const Passwords_1 = require("./Passwords");
const registrationCandidateFormRules_1 = require("./registrationCandidateFormRules");
const RegistrationCandidateForm_style_1 = require("./RegistrationCandidateForm.style");
function RegistrationCandidateForm() {
    const [form] = antd_1.Form.useForm();
    const intl = (0, react_intl_1.useIntl)();
    const history = (0, react_router_1.useHistory)();
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    const [showDataProcessingModal, setShowDataProcessingModal] = react_1.default.useState(false);
    const [showNesletterModal, setShowNesletterModal] = react_1.default.useState(false);
    const [loading, setLoading] = react_1.default.useState(false);
    const rules = (0, registrationCandidateFormRules_1.registrationCandidateFormRules)(intl);
    const { agreementRules } = rules;
    const onSubimt = async (registrationFormValues) => {
        try {
            setLoading(true);
            const registrationResponse = await Api.Registration.registerCandidate({
                ...registrationFormValues,
                account_type_id: 2,
            });
            if (registrationResponse.status === 201) {
                SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
                // @ts-ignore
                history.pushLocalized('/ucet');
                antd_1.notification.success({
                    message: intl.formatMessage({
                        id: 'general.warning',
                    }),
                    description: intl.formatMessage({
                        id: 'registration.registration_form.registration_success',
                    }),
                });
            }
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        }
        finally {
            setLoading(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(antd_1.Form, { form: form, layout: "vertical", onFinish: onSubimt, scrollToFirstError: true, children: [(0, jsx_runtime_1.jsx)(PersonalInformation_1.PersonalInformation, { rules: rules, intl: intl }), (0, jsx_runtime_1.jsx)(Passwords_1.Passwords, { rules: rules, intl: intl }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-row", children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.CandidateRegistrationFormField.protection, valuePropName: "checked", rules: agreementRules, children: (0, jsx_runtime_1.jsxs)(elements_1.Checkbox, { children: [(0, jsx_runtime_1.jsx)(RegistrationCandidateForm_style_1.RedText, { children: "*" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration_student.registration_student_form.protection" })] }) }), (0, jsx_runtime_1.jsx)(RegistrationCandidateForm_style_1.QuestionMarkWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.QuestionMark, { onClick: () => setShowDataProcessingModal(true) }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-row", children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: types_1.CandidateRegistrationFormField.newsletter, valuePropName: "checked", children: (0, jsx_runtime_1.jsx)(elements_1.Checkbox, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration_student.registration_student_form.newsletter" }) }) }), (0, jsx_runtime_1.jsx)(RegistrationCandidateForm_style_1.QuestionMarkWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.QuestionMark, { onClick: () => setShowNesletterModal(true) }) })] }), (0, jsx_runtime_1.jsx)(RegistrationCandidateForm_style_1.SubmitButtonWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.Button, { color: "brand", htmlType: "submit", loading: loading, children: (0, jsx_runtime_1.jsx)("span", { className: "m-l-xxs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration.registration_form.register" }) }) }) }), (0, jsx_runtime_1.jsxs)(RegistrationCandidateForm_style_1.RequiredWrapper, { children: [(0, jsx_runtime_1.jsx)(RegistrationCandidateForm_style_1.RedText, { children: "*" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "registration_student.registration_student_form.mandatory" })] })] }), (0, jsx_runtime_1.jsx)(DataProcessingOrNewsletterModal_1.DataProcessingOrNewsletterModal, { visible: showDataProcessingModal, setVisible: setShowDataProcessingModal, textId: "registration.registration_form.data_processing" }), (0, jsx_runtime_1.jsx)(DataProcessingOrNewsletterModal_1.DataProcessingOrNewsletterModal, { visible: showNesletterModal, setVisible: setShowNesletterModal, textId: "registration_student.registration_student_form.email_agreement" })] }));
}
